import { render, staticRenderFns } from "./quoteApproval.vue?vue&type=template&id=451a22df&scoped=true&"
import script from "./quoteApproval.vue?vue&type=script&lang=js&"
export * from "./quoteApproval.vue?vue&type=script&lang=js&"
import style0 from "./quoteApproval.vue?vue&type=style&index=0&id=451a22df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a22df",
  null
  
)

export default component.exports